import { preview } from './preview';
import { jobsite, pod } from './builder';
import { OneClickConfig } from '../../../../models/one-click-config.model';
import { ShippingLocationModeCode } from '../../../../models/shipping-location-mode.model';

export const delivery: OneClickConfig = {
  preview: preview,
  builder: {
    [ShippingLocationModeCode.Jobsite]: jobsite,
    [ShippingLocationModeCode.PointOfDelivery]: pod,
  },
};
